import { MessageCommonType } from '@/types/common/message';
import { acceptHMRUpdate, defineStore } from 'pinia';

const initialState: MessageCommonType = {
  field_error: [],
  isShow: false,
};

export const useMessageStore = defineStore('messages.store', {
  state: (): MessageCommonType => ({ ...initialState }),
  getters: {},
  actions: {
    showMesssages() {
      return this.field_error.map(field => field.message).join(',');
    },
  },
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useMessageStore, import.meta.hot));
}
